import { render, staticRenderFns } from "./DefinePasswordCard.vue?vue&type=template&id=2bd97a88"
import script from "./DefinePasswordCard.vue?vue&type=script&lang=js"
export * from "./DefinePasswordCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports